// v-reveal: la sección aparece al entrar en pantalla, como el `.reveal` del diseño.
// Va en elementos sin :class, porque Vue reescribiría la clase y la escondería.
let observador = null;

function obtener() {
  if (!observador && 'IntersectionObserver' in window) {
    observador = new IntersectionObserver((entradas) => entradas.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observador.unobserve(e.target);
      }
    }), { threshold: 0.1 });
  }
  return observador;
}

export default {
  mounted(el) {
    el.classList.add('reveal');
    const obs = obtener();
    if (obs) obs.observe(el);
    else el.classList.add('visible');
  },
  unmounted(el) {
    if (observador) observador.unobserve(el);
  },
};
